<template>
    <section id="wrapper" class="login-register login-sidebar">
        <div class="login-box card">
            <div class="card-body">
                <b-form class="form-horizontal" @submit="onSubmit" @reset="onReset" novalidate="">
                    <router-link :to="{'name': 'login'}" class="text-center db">
                        <img src="../assets/template/images/logo.png" alt="Consyst" style="height: 150px" />
                    </router-link>
                    <div class="form-group m-t-40">
                        <div class="col-xs-12">
                            <input type="text" class="form-control" placeholder="Login" v-model="form.username">
                            <label v-if="!(valid.username)" id="username-error" class="error" for="username">Login inválido!</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-12">
                            <input type="password" class="form-control" placeholder="Senha" v-model="form.password">
                            <label v-if="!(valid.password)" id="password-error" class="error" for="password">Senha inválida!</label>
                        </div>
                    </div>
                    <div class="form-group text-center m-t-20">
                        <div class="col-xs-12">
                            <button class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Logar</button>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
    </section>
</template>
<script>
    import validation from '../services/validations.service';

    export default {
        mounted: function () {

        },
        data() {
            return {
                form: {
                    username: '',
                    password: ''
                },
                valid: {
                    username: true,
                    password: true
                }
            };
        },
        methods: {
            onSubmit(_evt) {
                _evt.preventDefault();
                var self = this;
                var valid = true;

                self.valid.username = true;
                self.valid.password = true;

                if (self.form.username == '') {
                    self.valid.username = false;
                    valid = false;
                }

                if (validation.password(self.form.password) < 30) {
                    self.valid.password = false;
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');
                    const response = self.$store.dispatch('auth/login', self.form);

                    response.then(function (_data) {
                        const responsePermissions = self.$store.dispatch("menu/all");
                        responsePermissions.then(function(_data) {
                            self.$root.$emit('onLoading');
                            var canAccessProposalsModule = false;
                            var canAccessFormalizationsModule = false;
                            _data.find(permission => {
                                permission.functionalities.find(functionality => {
                                    if (functionality.route == "contracts") {
                                        canAccessFormalizationsModule = true
                                    }
                                    if (functionality.route == "proposals") {
                                        canAccessProposalsModule = true
                                    }
                                })
                            })

                            if (canAccessProposalsModule) {
                                self.$root.$emit("restartTimerLogoff");
                                self.$router.push({'name': 'proposals.index'});
                            } else if (canAccessFormalizationsModule) {
                                self.$root.$emit("restartTimerLogoff");
                                self.$router.push({'name': 'contracts.index'});
                            } else {
                                self.$notify.error("Usuário sem permissões básicas!");
                            }
                        })

                        responsePermissions.catch(function(_err) {
                            if (_err.status == 401) {
                                self.$notify.error("Credenciais inválidas!");
                            }
                            self.$root.$emit('onLoading');
                        })
                        
                        //self.$router.push({'name': 'proposals.index'});
                    });

                    response.catch(function (_err) {
                        if (_err.status == 401) {
                            self.$notify.error("Credenciais inválidas!");
                        }
                        self.$root.$emit('onLoading');
                    });
                }
            },
            onReset(_evt) {
                _evt.preventDefault();
                /* Reset our form values */
                this.form.email = '';
                this.form.pasword = '';
            }
        }
    };
</script>

<style scoped>
    #wrapper{
        background-image:url(../assets/template/images/background/base.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
    }
</style>